const ORIGINAL_USER_TOKEN_KEY = 'original_user.token';
const ORIGINAL_USER_NAME_KEY = 'original_user.name';

export default function({ app, $axios, $config }) {

    // Create some helpers to access props of the authenticated user
    app.$auth.id = app.$auth.user ? app.$auth.user.id : null
    app.$auth.token = app.$auth.getToken('local');
    app.$auth.isImpersonating = !!app.$auth.$storage.getUniversal(ORIGINAL_USER_TOKEN_KEY);
    app.$auth.originalUserName = app.$auth.$storage.getUniversal(ORIGINAL_USER_NAME_KEY);

    // Method to impersonate as another user for admins
    app.$auth.impersonate = async (userId) => {
        if (!app.$auth.user || !app.$auth.user.is_admin) {
            return;
        }

        const currentAuthToken = app.$auth.token;
        const response = await $axios.post(`${$config.apiUrl}/v1/auth/user/${userId}/impersonate`);

        app.$auth.$storage.setUniversal(ORIGINAL_USER_TOKEN_KEY, currentAuthToken.replace('Bearer ', ''))
        app.$auth.isImpersonating = true;

        app.$auth.$storage.setUniversal(ORIGINAL_USER_NAME_KEY, app.$auth.user.display_name)
        app.$auth.originalUserName = app.$auth.user.display_name;

        const impersonatedUserToken = response.data.access_token;
        await app.$auth.setUserToken(impersonatedUserToken);
        window.location.href = $config.spoferanUrl;
    }
    app.$auth.stopImpersonate = async () => {
        const originalAuthToken = app.$auth.$storage.getUniversal(ORIGINAL_USER_TOKEN_KEY);
        if (originalAuthToken) {
            await $axios.post(`${$config.apiUrl}/v1/auth/logout`); // Revokes the impersonating token on the API
            await app.$auth.setUserToken(originalAuthToken);

            app.$auth.$storage.removeUniversal(ORIGINAL_USER_TOKEN_KEY);
            app.$auth.isImpersonating = false;

            app.$auth.$storage.removeUniversal(ORIGINAL_USER_NAME_KEY);
            app.$auth.originalUserName = null;

            window.location.reload(true)
        } else {
            app.$auth.isImpersonating = false;
            app.$auth.originalUserName = null;
            await app.$auth.logout()
        }
    }

    refreshSentryConfig(app);
    refreshAnalyticsProps(app);

    // Make sure the user role helper gets updated when the user updates
    app.$auth.$storage.watchState('user', user => {
        app.$auth.id = user ? user.id : null
        app.$auth.token = app.$auth.getToken('local');

        // Handle logout while impersonating
        if (!user) {
            app.$auth.$storage.removeUniversal(ORIGINAL_USER_TOKEN_KEY);
            app.$auth.isImpersonating = false;
            app.$auth.$storage.removeUniversal(ORIGINAL_USER_NAME_KEY);
            app.$auth.originalUserName = null;
        }

        refreshSentryConfig(app);
        refreshAnalyticsProps(app);
    })
}

function refreshAnalyticsProps(app) {
    // Push the user custom dimensions to the gtm data layer
    let userRole = 'guest';
    if (app.$auth.user) {
        if (app.$auth.user.roles.includes('admin')) {
            userRole = 'admin';
        } else {
            userRole = 'user';
        }
    }

    app.$analytics.track({
        user_role: userRole
    });
}

function refreshSentryConfig(app) {
    if (app.$auth.user && process.client) {
        if (app.$sentry) {
            app.$sentry.configureScope((scope) => {
                scope.setUser({
                    id: app.$auth.user.id
                })
            })
        }
    }
}